import React from 'react';
import GroupHeading from '../atoms/GroupHeading';

// Geometry mirrors a real ShortcutList row.
export function ShortcutListSkeleton() {
  return (
    <section aria-hidden="true" data-testid="global-search-shortcuts-skeleton">
      <GroupHeading label="Pinned shortcuts" />
      <ul>
        {[0, 1, 2, 3].map((index) => (
          <li key={index} className="flex items-center gap-2.5 rounded-(--gs-row-radius) px-2.5 py-(--gs-row-padding-y)">
            <span className="size-8 shrink-0 animate-pulse rounded-full bg-llama-grey-3" />
            <div className="min-w-0 flex-1 space-y-1.5">
              <div className="h-3.5 w-2/5 animate-pulse rounded bg-llama-grey-3" />
              <div className="h-3 w-3/5 animate-pulse rounded bg-llama-grey-3" />
            </div>
            <div className="h-5 w-5 shrink-0 animate-pulse rounded-(--el-radius-rounded-xs) bg-llama-grey-3" />
          </li>
        ))}
      </ul>
    </section>
  );
}

export function SkeletonRows() {
  return (
    <div className="space-y-6" aria-hidden="true" data-testid="global-search-skeleton">
      {[0, 1].map((groupIndex) => (
        <div key={groupIndex}>
          <div className="mb-2 flex items-center justify-between">
            <div className="h-3 w-24 animate-pulse rounded bg-llama-grey-3" />
            <div className="h-3 w-10 animate-pulse rounded bg-llama-grey-3" />
          </div>
          {[0, 1].map((rowIndex) => (
            <div key={rowIndex} className="flex items-center gap-2.5 rounded-(--gs-row-radius) px-2.5 py-(--gs-row-padding-y)">
              {/* Real rows always reserve this 32px slot, avatar or not, to keep titles aligned. */}
              <span className="flex size-8 shrink-0 items-center justify-center">
                {groupIndex === 0 && <span className="size-8 animate-pulse rounded-full bg-llama-grey-3" />}
              </span>
              <div className="min-w-0 flex-1 space-y-1.5">
                <div className="h-3.5 w-2/5 animate-pulse rounded bg-llama-grey-3" />
                <div className="h-3 w-3/5 animate-pulse rounded bg-llama-grey-3" />
              </div>
              <div className="flex shrink-0 items-center gap-3">
                <div className="h-5 w-16 animate-pulse rounded-full bg-llama-grey-3" />
                <div className="h-3 w-12 animate-pulse rounded bg-llama-grey-3" />
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
